$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
ModelLoader = require 'app/scripts/db/model-loader'
Payloads = require 'app/scripts/network/payloads'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
LabelLimitsErrorView = require 'app/scripts/views/label/label-limits-error-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
template = require 'app/scripts/views/templates/popover_move_list'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'

tooManyCustomFieldsError = 'BOARD_TOO_MANY_CUSTOM_FIELDS'
tooManyCustomFieldOptionsError = 'CUSTOM_FIELD_TOO_MANY_OPTIONS'

module.exports = class ListMoveView extends View
  viewTitleKey: 'move list'

  tagName: 'form'

  events:
    'change .js-select-list-pos': 'renderValues'
    'change .js-select-board': 'updateBoardData'
    'click .js-commit-position': 'commitChange'
    'submit': 'commitChange'

  render: ->
    view = @
    model = view.model

    data = {}
    currentBoard = @model.getBoard()
    enterprise = @model.getBoard().getEnterprise()
    showFeature = featureFlagClient.get('enterprise.restrict-moves-and-copies-into-teams-within-enterprise', false)
    if enterprise? && showFeature
      data.hasEnterprise = true
      data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(true, enterprise.get('id'))
      data.enterpriseName = enterprise.get('displayName')
    else
      currentBoard = if @model.getBoard().isEditableByTeamMemberAndIsNotABoardMember() then currentBoard else null
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard)

    for org in data.organizations
      for board in org.boards
        if board.id == model.get('idBoard')
          board.selected = true

    @$el.html(
      template(data)
    )

    @updateBoardData()

    @

  renderValues: ->
    $el = $(@el)

    idBoard = $el.find('.js-select-board option:selected').val()
    index = parseInt($el.find('.js-select-list-pos option:selected').text(), 10)

    board = @modelCache.get('Board', idBoard)
    boardName = board.get('name')

    $el.find('.js-board-value').text boardName
    $el.find('.js-pos-value').text String(index)

    return

  updateBoardData: ->
    $el = $(@el)
    $selectBoard = $el.find('.js-select-board')
    idBoardSelected = $selectBoard.find('option:selected').val()

    if idBoardSelected == @model.getBoard().id
      @_boardData = @model.getBoard()
      for list in @_boardData.listList.models
        list.cardCount = @_boardData.listList.get(list.id).openCards().length
      @updateListList()
    else
      $otherSelects = $el.find('.select-list,.select-position')
      $otherSelects.attr('disabled', 'disabled')
      ModelLoader.loadBoardData idBoardSelected, Payloads.listsMinimal
      .then =>
        @_boardData = @modelCache.get('Board', idBoardSelected)
        @updateListList()
        $otherSelects.removeAttr('disabled')
      .done()
    return

  updateListList: ->
    view = @
    model = view.model

    $selectList = @$('.js-select-list-pos')
    $selectList.empty()

    openLists = @_boardData.listList.models
    isCurrentBoard = @_boardData.id == @model.getBoard().id

    if isCurrentBoard
      currentIndex = _.indexOf openLists, @model
      count = openLists.length
    else
      currentIndex = -1
      count = openLists.length + 1

    for i in [0...count]
      indexString = String(i + 1)
      desc = if i == currentIndex
        l('current position', { index: indexString })
      else
        indexString

      pos = @_boardData.listList.calcPos(i, model)
      $option = $('<option>').val(pos).text(desc).appendTo($selectList)
      if i == currentIndex
        $option.attr('selected', 'selected')

    $commitButton = @$('.js-commit-position')
    $limitExceededError = @$('.js-list-limit-exceeded')
    if !isCurrentBoard
      tooManyLists = @_boardData.isOverLimit('lists', 'totalPerBoard') ||
        @_boardData.isOverLimit('lists', 'openPerBoard')
      $commitButton
        .toggleClass('disabled', tooManyLists)
        .prop('disabled', tooManyLists)
      $limitExceededError.toggleClass('hide', !tooManyLists)
    else
      $commitButton
        .toggleClass('disabled', false)
        .prop('disabled', false)
      $limitExceededError.toggleClass('hide', true)

    @renderValues()

  commitChange: (e) ->
    Util.stop(e)

    $selectListPos = @$('.js-select-list-pos')
    listPosSelected = parseInt($selectListPos.find('option:selected').val(), 10)
    idBoardSelected = @$('.js-select-board option:selected').val()

    @model.getBoard().composer.save("vis", false)

    originalBoardId = @model.getBoard().id
    originalPosition = @model.get('pos')

    if idBoardSelected == originalBoardId
      @model.update({ pos: listPosSelected })
      track("List Menu", "Move Menu", "Successfully Moved")
    else if idBoardSelected? && listPosSelected?
      if @model.cardList.length > 0
        hasAttachments = hasChecklists = false
        @model.cardList.forEach (card) ->
          hasAttachments = hasAttachments || card.attachmentList.length > 0
          hasChecklists = hasChecklists || card.checklistList.length > 0

        options = {
          $elem: $(e.target),
          hasChecklists: hasChecklists,
          hasAttachments: hasAttachments,
          destinationBoard: @_boardData,
        }
        if maybeDisplayLimitsErrorOnCardAdd(options)
          return

      hasLabels = @model.cardList.filter (c) ->
        c.getLabels().length > 0
      if hasLabels && @_boardData.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

      next = (response) =>
        # If there's an error:
        # - Show an alert for custom fields limit errors
        # - Revert the move back to its original board and position
        if response?.message?
          errorMessage = JSON.parse(response.message)?.error

          if errorMessage == tooManyCustomFieldsError
            Alerts.show('too many custom fields', 'error', 'movelist', 8000)
          else if errorMessage == tooManyCustomFieldOptionsError
            Alerts.show('too many custom options', 'error', 'movelist', 8000)

          @model.set({ idBoard: originalBoardId, pos: originalPosition }, next)

      @model.update({ idBoard: idBoardSelected, pos: listPosSelected }, next)
      track("List Menu", "Move Menu", "Changed Board")

    PopOver.hide()
    return
